import { render } from "./ProfileStatsLessons.vue?vue&type=template&id=5ffcf381&scoped=true"
import script from "./ProfileStatsLessons.vue?vue&type=script&lang=js"
export * from "./ProfileStatsLessons.vue?vue&type=script&lang=js"

import "./ProfileStatsLessons.vue?vue&type=style&index=0&id=5ffcf381&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffcf381"]])

export default __exports__